<i18n
  src="@/locales/views/service_provider/services/container_op/new_schedule.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container_scheduled_service.yml" lang="yaml"></i18n>
<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    name="sp_services_container_op_path"
    :params="{
      service_provider_id: service_provider_id,
    }"
  />
  <bread-crumbs :labels="[module_name]"></bread-crumbs>
  <alert-danger :errors_data="std_err" />
  <div class="mt-8">
    <div class="panel">
      <div class="panel-header">
        <h3 class="panel-header-title">
          {{ $t("labels.title") }}
        </h3>
      </div>
      <div class="panel-body">
        <div class="space-y-8 divide-y divide-gray-200">
          <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-6">
              <label class="label-form">
                {{ $t("model.container_scheduled_service.agro_exporter_id") }}
              </label>
              <div class="mt-1">
                <select-form
                  v-if="agro_exporters.length > 1"
                  class="custom-tailwind-select w-full"
                  :options="agro_exporters"
                  v-model="agro_exporter_id"
                  label="name"
                />
                <div
                  class="content-data w-full"
                  v-else-if="agro_exporters.length == 1"
                >
                  {{ agro_exporters[0]?.name }}
                </div>
              </div>
            </div>
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.container_scheduled_service.scheduled_at") }}
              </label>
              <div class="mt-1">
                <date-form
                  v-model="container_scheduled_service.scheduled_at"
                  mode="dateTime"
                  :first-day-of-week="2"
                  locale="es"
                  show-iso-weeknumbers
                ></date-form>
              </div>
            </div>
            <div class="sm:col-span-3">
              <dt class="label-form">
                {{ $t("model.container_scheduled_service.status_id") }}
              </dt>
              <dd class="mt-1">
                <container-scheduled-service-status-selector
                  v-model="container_scheduled_service.status_id"
                />
              </dd>
            </div>
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.container_scheduled_service.started_at") }}
              </label>
              <div class="mt-1">
                <date-form
                  v-model="container_scheduled_service.started_at"
                  mode="dateTime"
                  :first-day-of-week="2"
                  locale="es"
                  show-iso-weeknumbers
                ></date-form>
              </div>
            </div>
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.container_scheduled_service.finished_at") }}
              </label>
              <div class="mt-1">
                <date-form
                  v-model="container_scheduled_service.finished_at"
                  mode="dateTime"
                  :first-day-of-week="2"
                  locale="es"
                  show-iso-weeknumbers
                ></date-form>
              </div>
            </div>
            <div class="sm:col-span-6">
              <label class="label-form">
                {{ $t("model.container_scheduled_service.observations") }}
              </label>
              <div class="mt-1">
                <textarea
                  type="text"
                  v-model="container_scheduled_service.observations"
                  class="input-text"
                />
              </div>
            </div>
          </div>
          <div class="pt-2 pl-2">
            <ul class="list-none">
              <li
                v-for="service_template in service_templates"
                :key="service_template.id"
                class="pt-2"
              >
                <switch-form
                  v-model="active_service_templates[service_template.id]"
                  :label="service_template.name"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="panel-footer" v-if="container_scheduled_service">
        <div class="panel-footer-actions">
          <div class="panel-footer-actions">
            <white-button @click.prevent="goToList()" :label='$t("labels.cancel_button")' />
            <span class="space-actions"></span>
            <success-button v-if="!charging_submit" @click.prevent="submit()" :label="$t('labels.save_button')" />
            <success-button-processing v-else :label="$t('labels.save_button')" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div />
</template>

<script>
import Requester from "@/views/service_provider/requesters/services/container_op/new_schedule.js";
import ContainerScheduledServiceStatusSelector from "@/components/views/service_provider/services/container_op/ContainerScheduledServiceStatusSelector.vue";
import BreadCrumbs from "@/components/views/layout/BreadCrumbs.vue";

import moment from "moment";

export default {
  components: {
    BreadCrumbs,
    ContainerScheduledServiceStatusSelector,
  },
  props: ["service_provider_id"],
  data() {
    return {
      agro_exporter_id: null,
      agro_exporters: [],
      container_scheduled_service: {},
      service_templates: [],
      active_service_templates: {},
      charging_submit: false,
    };
  },
  computed: {
    can_send: function () {
      return !this.charging_submit;
    },
    finished_at_formated: function () {
      let finished_at = this.container_scheduled_service?.finished_at;
      if (finished_at) return moment(finished_at).format("YYYY-MM-DD hh:mm a");
      return "";
    },
    service_templates_params: function () {
      return this.service_templates
        .map((service_template) => {
          return {
            id: service_template.id,
          };
        })
        .filter(
          (service_template) =>
            this.active_service_templates[service_template.id]
        );
    },
    params: function () {
      return {
        scheduled_at: this.scheduled_at_formated,
        started_at: this.started_at_formated,
        finished_at: this.finished_at_formated,
        status_id: this.container_scheduled_service.status_id,
        observations: this.container_scheduled_service.observations,
        agro_exporter_id: this.agro_exporter_id,
        service_provider_id: this.service_provider_id,
        service_templates: this.service_templates_params,
      };
    },
    save_link_class: function () {
      let basic_class = "btn-main";
      if (this.can_send) return basic_class;
      return `${basic_class}  opacity-50 cursor-not-allowed`;
    },
    scheduled_at_formated: function () {
      let scheduled_at = this.container_scheduled_service?.scheduled_at;
      if (scheduled_at)
        return moment(scheduled_at).format("YYYY-MM-DD hh:mm a");
      return "";
    },
    started_at_formated: function () {
      let started_at = this.container_scheduled_service?.started_at;
      if (started_at) return moment(started_at).format("YYYY-MM-DD hh:mm a");
      return "";
    },
  },
  methods: {
    fetchAgroExporters: async function () {
      let response = await Requester.fetchAgroExporters({
        service_provider_id: this.service_provider_id,
      });
      this.agro_exporters = response.data;
      if (this.agro_exporters.length == 1)
        this.agro_exporter_id = this.agro_exporters[0]?.id;
    },
    fetchServiceTemplates: async function () {
      let response = await Requester.fetchServiceTemplates({
        service_provider_id: this.service_provider_id,
      });
      this.service_templates = response.data;
    },
    goToList: function () {
      this.$router.push({
        name: "sp_services_container_op_path",
        params: {
          service_provider_id: this.service_provider_id,
        },
      });
    },
    submit: async function () {
      if (!this.can_send) return;
      this.charging_submit = true;
      try {
        let response = await Requester.create(this.params);
        this.registerSuccessNotification({
          title: response.data.success_message,
        });
        this.goToList();
      } catch (error) {
        if (error?.response?.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields,
          });
        }
      }
      this.charging_submit = false;
    },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          service_provider_id: this.service_provider_id,
        },
      }).then(() => {
        this.fetchAgroExporters();
        this.fetchServiceTemplates();
      })
    );
  },
};
</script>
